/*    
<summary>
  This File contains all the routes constant. 
  Developer:Mohammad Saquib Khan, Created Date:24-April-2025
</summary>
*/

import config from "../helpers/config-helper";
import StoreDetails from "../modules/store-management/store-details/store-details";

// Get application configuration
const appConfig = config();
// Get base public URL from config
const baseURL = appConfig.REACT_APP_PUBLIC_URL;

// All application route constants
const RoutesConstants = {
  // Authentication routes
  // Login: baseURL + "/login",
  Logout: baseURL + "/logout",
  AccountActivation: baseURL + "/AccountActivation",
  ResetPassword: baseURL + "/ResetPassword",
  ForgotPassword: baseURL + "/ForgotPassword",
  ChangePassword: baseURL + "/ChangePassword",

  // Main dashboard
  Dashboard: baseURL + "/Dashboard",

  // Customer management
  CustomerManagement: baseURL + "/CustomerManagement",

  // Reservation related routes
  ReservationList: baseURL + "/ReservationList",
  ReservationSettings: baseURL + "/ReservationSettings",
  ReservationDetails: baseURL + "/ReservationDetails",
  ReservationManagement: baseURL + "/ReservationManagement",
  CancelledReservation: baseURL + "/CancelledReservation",

  // Store management
  StoreList: baseURL + "/StoreList",
  StoreDetails: baseURL + "/StoreDetails",
  StoreTreatmentList: baseURL + "/StoreTreatmentList",
  StoreProductList: baseURL + "/StoreProductList",
  StoreOptionMenuList: baseURL + "/StoreOptionMenuList",
  StoreStaffInformation: baseURL + "/StoreStaffInformation",
  StoreCmsDetails: baseURL + "/StoreCmsDetails",

  // Treatment and product management
  TreatmentList: baseURL + "/TreatmentList",
  CategoryList: baseURL + "/CategoryList",
  ProductList: baseURL + "/ProductList",

  // Staff management
  StaffInformation: baseURL + "/StaffInformationList",
  ShiftManagement: baseURL + "/ShiftManagement",

  // Settings
  Settings: baseURL + "/Settings",
  OptionMenuList: baseURL + "/OptionMenuList",
  TaxSettings: baseURL + "/TaxSettings",
  TimeSettings: baseURL + "/TimeSettings",
  BusinessTypeSettings: baseURL + "/BusinessTypeSettings",
  StoreMotivationSettings: baseURL + "/StoreMotivationSettings",
  PaymentModeSettings: baseURL + "/PaymentModeSettings",

  // Booking management
  BookingManagement: baseURL + "/BookingManagement/:storeCode",
  CustomerBookingManagement: baseURL + "/Customer/BookingManagement/:storeCode",

  // Agreement management
  AgreementList: baseURL + "/AgreementList",
  AgreementRegistration: baseURL + "/AgreementRegistration",
  AgreementDetails: baseURL + "/AgreementDetails",

  // Sales and records
  SalesMedicalRecords: baseURL + "/SalesMedicalRecords",

  // Headquarter management
  HeadquarterManagement: baseURL + "/HeadquarterManagement",

  // Customer portal routes
  CustomerLogin: baseURL + "/customer/login",
  StoreLogin: baseURL + "/store/login",
  HeadQuarterLogin: baseURL + "/headquarter/login",
  StaffLogin: baseURL + "/staff/login",
  GroupLogin: baseURL + "/group/login",
  AdminLogin: baseURL + "/admin/login",
  CustomerRegistration: baseURL + "/customer/registration",

  // Miscellaneous
  Home: baseURL + "/Home",
  // NavigationPage: baseURL + "/NavigationPage",
  Profile: baseURL + "/Profile",
  ConsumptionTax: baseURL + "/ConsumptionTax",
  UploadIcons: baseURL + "/UploadIcons",
  UploadTemplates: baseURL + "/UploadTemplates",
  CancelationPolicy: baseURL + "/CancelationPolicy",
  ChangeAgreementPassword: baseURL + "/ChangeAgreementPassword",
  MotivationInStore: baseURL + "/MotivationInStore",
  PaymentInStore: baseURL + "/PaymentInStore",
  ThemeInStore: baseURL + "/ThemeInStore",
  LizeraStoreList: baseURL + "/LizeraStoreList",
  StoreListPage: baseURL + "/StoreListing",
  LizeraStoreDetails: baseURL + "/LizeraStoreDetails/StoreId/:storeId",


  InventoryManagement: baseURL + "/Inventory",
  EmailManagement: baseURL + "/EmailManagement",
  LizeraStore: baseURL + "/Store",
  TotallingManagementDaily: baseURL + "/Totalling/Daily",
  TotallingManagementWeekly: baseURL + "/Totalling/Weekly",
  TotallingManagementMonthly: baseURL + "/Totalling/Monthly",
  TotallingManagementStaffSales: baseURL + "/Totalling/Staff",
  TotallingManagementPeriodSales: baseURL + "/Totalling/Period",

  InvalidStore: baseURL + "/InvalidStore",
  PageNotFound: baseURL + "/PageNotFound",
  
};

export default RoutesConstants;
